import React, { useState, useEffect } from 'react';
import { Input } from '../ui/input';
import { MaskedInput } from '../ui/masked-input';
import { localDateISO, parseQuantityInput } from '../../lib/utils';

function ProductionReportForm({ onSubmit, loading, movementTypes, defaultMovementTypeId, productLabel, warehouseLabel }) {
    const [formData, setFormData] = useState(() => ({
        produced_quantity: '',
        date: localDateISO(),
        duration: '',
        movement_type_id: '',
        notes: '',
    }));

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            movement_type_id: defaultMovementTypeId ? String(defaultMovementTypeId) : prev.movement_type_id || '',
        }));
    }, [defaultMovementTypeId]);

    const inTypes = (movementTypes || []).filter((t) => t.direction === 'in');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const [hours, minutes] = formData.duration.split(':').map(Number);
        const payload = {
            produced_quantity: parseQuantityInput(formData.produced_quantity),
            datetime: formData.date,
            duration_minutes: hours * 60 + minutes,
            notes: formData.notes || null,
        };
        if (formData.movement_type_id) {
            payload.movement_type_id = parseInt(formData.movement_type_id, 10);
        }
        onSubmit(payload);
    };

    return (
        <form id="production-report-form" onSubmit={handleSubmit} className="space-y-4">
            {(productLabel || warehouseLabel) && (
                <div className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700 space-y-1">
                    {productLabel && (
                        <p>
                            <span className="font-medium text-gray-900">Produto: </span>
                            {productLabel}
                        </p>
                    )}
                    {warehouseLabel && (
                        <p>
                            <span className="font-medium text-gray-900">Depósito destino: </span>
                            {warehouseLabel}
                        </p>
                    )}
                </div>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Data *</label>
                    <MaskedInput
                        mask="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Duração *</label>
                    <MaskedInput
                        mask="time"
                        name="duration"
                        value={formData.duration}
                        onChange={handleChange}
                        pattern="\d{2}:[0-5]\d"
                        title="hh:mm"
                        required
                    />
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de movimentação (produto acabado) *</label>
                <select
                    name="movement_type_id"
                    value={formData.movement_type_id}
                    onChange={handleChange}
                    className="flex h-10 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                    required
                >
                    <option value="">Selecione...</option>
                    {inTypes.map((t) => (
                        <option key={t.id} value={t.id}>
                            {t.code} - {t.name}
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Quantidade Produzida *</label>
                <Input
                    type="number"
                    step="0.001"
                    name="produced_quantity"
                    value={formData.produced_quantity}
                    onChange={handleChange}
                    required
                    min="0.001"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Observações</label>
                <textarea
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    rows={4}
                    className="flex w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                />
            </div>
        </form>
    );
}

export default ProductionReportForm;
